import { useCompassCard } from '@scale/compass-ui/store';
import { useEffect, useMemo, useState } from 'react';
import {
  GenericAutoOpsContext,
  CardTypeToStepType,
} from '@scale/genai-compass-shared/autoops/cards';
import { Steps } from '@scale/shared/types/ruleEngine/stepList';
import { DataCompassUtils } from 'react-scale/corp/views/DataCompassV2/dataCompassUtils';
import { StepConfiguration, StepTypes } from '@scale/shared/types/ruleEngine/step';

function useGenericAutoOpsCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit, error } = useCompassCard(index);
  const context = card.defaultContext as GenericAutoOpsContext<any>;
  const cardType = context.cardType;
  const [hasProcessedStep, setHasProcessedStep] = useState<boolean>(context.hasProcessedStep);
  const { retrievedOutput } = useCompassCard(index - 1);

  const [step, setStep] = useMemo(() => {
    let currentStep = context.step as StepConfiguration<StepTypes>;
    if (!hasProcessedStep) {
      const stepType = CardTypeToStepType[
        cardType as keyof typeof CardTypeToStepType
      ] as keyof typeof Steps;
      currentStep = DataCompassUtils.getProcessedGenericAutoOpsStep(
        cardType,
        Steps[stepType] as StepConfiguration<StepTypes>,
        retrievedOutput,
      );
      context.step = currentStep;
      context.hasProcessedStep = true;
      setHasProcessedStep(true);
    }
    const setNewStep = (newStep: StepConfiguration<StepTypes> | undefined) => {
      if (newStep) {
        const updatedContext: GenericAutoOpsContext<any> = {
          ...context,
          step: newStep,
        };
        updateCardContext(updatedContext);
      }
    };
    return [currentStep, setNewStep] as const;
  }, [context, hasProcessedStep, cardType, retrievedOutput, updateCardContext]);

  // TODO: Add validation for all required fields being filled out

  // const isEmptyValue = (value: unknown): boolean => {
  //   return (
  //     value === undefined ||
  //     ((Array.isArray(value) || typeof value === 'string') && value.length === 0)
  //   );
  // };

  // Check if all the required fields of the step are filled
  // useEffect(() => {
  //   let canSubmit = true;
  //   for (const param in step.parameterTypes) {
  //     if (
  //       param &&
  //       !step.parameterTypes[param].optional &&
  //       isEmptyValue(step.parameterTypes[param].value)
  //     ) {
  //       canSubmit = false;
  //       break;
  //     }
  //   }
  //   updateCardCanSubmit(canSubmit);
  // }, [step, updateCardCanSubmit]);

  useEffect(() => {
    updateCardCanSubmit(true);
  }, []);

  return { step, setStep, hasProcessedStep, setHasProcessedStep, hasError: !!error };
}

export default useGenericAutoOpsCard;
